import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/booking-extras`, formData);
  },
  async findOne({ id }) {
    return axios.get(`/booking-extras/${id}`);
  },
  async findAll() {
    return axios.get(`/booking-extras`);
  },
  async delete({ id }) {
    return axios.delete(`/booking-extras/${id}`);
  },
  async update(formData) {
    return axios.put(`/booking-extras/${formData.id}`, formData);
  }
};
